function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["className"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { TextLink } from "./textlink";
import * as Accordion from '@radix-ui/react-accordion';
import React, { useMemo, useState } from 'react';
import * as styles from "../style/collapse";
import { cn } from "../../lib/utils";
import { ArrowchevronDownIcon } from '@bfe/moly-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AccordionTrigger = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var icon = props.icon;
  return /*#__PURE__*/_jsx(Accordion.Header, {
    ref: forwardedRef,
    className: styles.AccordionHeader,
    children: /*#__PURE__*/_jsxs(Accordion.Trigger, _objectSpread(_objectSpread({
      className: cn(styles.AccordionTrigger, className, 'transition-all focus-visible:outline-none ring-focus-default focus-visible:ring-[5px] ring-btn-default rounded-lg')
    }, props), {}, {
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.AccordionTitleContent,
        children: children
      }), icon ? /*#__PURE__*/_jsx("div", {
        className: "moly-collaspe-custom-icon transition-all",
        children: icon
      }) : /*#__PURE__*/_jsx(ArrowchevronDownIcon, {
        className: "moly-icon ".concat(styles.AccordionChevron, " transition-all")
      })]
    }))
  });
});
var AccordionContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Accordion.Content, _objectSpread(_objectSpread({
    className: cn(styles.AccordionContent, className),
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: styles.AccordionContentText,
      children: children
    })
  }));
});
var Collapse = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var items = props.items,
    moreLink = props.moreLink,
    onChange = props.onChange,
    type = props.type,
    collapsible = props.collapsible,
    defaultValue = props.defaultValue,
    value = props.value,
    icon = props.icon,
    moreText = props.moreText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var filterItems = useMemo(function () {
    if (showAll || items && (items === null || items === void 0 ? void 0 : items.length) < 8) {
      return items;
    }
    return items === null || items === void 0 ? void 0 : items.slice(0, 8);
  }, [showAll, items]);
  return /*#__PURE__*/_jsxs(Accordion.Root, {
    className: cn('moly-collapse', styles.AccordionRoot, className),
    type: type || 'single',
    onValueChange: onChange,
    ref: ref,
    collapsible: collapsible,
    defaultValue: defaultValue,
    value: value,
    children: [filterItems && filterItems.length > 0 && filterItems.map(function (item) {
      return /*#__PURE__*/_jsxs(Accordion.Item, {
        className: styles.AccordionItem,
        value: item.key,
        children: [/*#__PURE__*/_jsx(AccordionTrigger, {
          icon: icon,
          children: item === null || item === void 0 ? void 0 : item.label
        }), /*#__PURE__*/_jsx(AccordionContent, {
          children: item === null || item === void 0 ? void 0 : item.children
        })]
      }, item === null || item === void 0 ? void 0 : item.key);
    }), items && (items === null || items === void 0 ? void 0 : items.length) > 8 && !showAll && /*#__PURE__*/_jsxs(TextLink, {
      className: styles.viewMore,
      variant: "primary",
      closeIcon: true,
      size: "xlarge",
      onClick: function onClick() {
        return setShowAll(true);
      },
      children: [moreText !== null && moreText !== void 0 ? moreText : 'View more', /*#__PURE__*/_jsx(ArrowchevronDownIcon, {})]
    }), moreLink && /*#__PURE__*/_jsx(TextLink, {
      className: styles.viewMore,
      variant: "primary",
      size: "xlarge",
      onClick: function onClick() {
        return window.open(moreLink);
      },
      children: moreText !== null && moreText !== void 0 ? moreText : 'View more'
    })]
  });
});
Collapse.displayName = Accordion.Root.displayName;
export { Collapse };